import React from 'react'
import PropTypes from 'prop-types'
import { pure } from 'recompose'
import { startCase } from 'lodash'
import { filterInvalidDOMProps } from 'lp-components/lib/utils'

const propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
}

const defaultProps = {
  label: '',
}

function Legend({ label, name, ...rest }) {
  return (
    <legend {...filterInvalidDOMProps(rest)}>{label || startCase(name)}</legend>
  )
}

Legend.propTypes = propTypes
Legend.defaultProps = defaultProps

export default pure(Legend)
